/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';
import clsx from 'clsx';

import { useArticle, useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { postBy, formatArticleError } from '@utils';
import { getImage } from '@utils/media';

import s from './styles.module.less';

const SlideItem = ({ className, slide, onClick }) => {
  const { locale } = useParams();
  const { article, error } = useArticle(slide.articleId, locale);
  const { media } = useMedia(getImage(slide));
  const description = article.id ? postBy(article) : '';

  const title = error ? formatArticleError(error) : article.title || 'loading article...';

  return (
    <div className={clsx(className, s.slideItem)}>
      <InfoItem image={media.src} description={description}>
        {title}
      </InfoItem>
    </div>
  );
};

export default SlideItem;
